import axios from "axios";
import { getClientData } from "./auth";

export const baseURLAPI = process.env["REACT_APP_URL_EGAM_API"];

const egam = axios.create({
  baseURL: baseURLAPI ?? "",
});

egam.interceptors.request.use(async config => {
  const clientData = getClientData();
  const newConfig = config;
  if (clientData?.ds_token_egam) {
    newConfig.headers.Authorization = `Bearer ${clientData.ds_token_egam}`;
  }
  return newConfig;
});

export default egam;
